import rectangle from './rectangle';
import polyline from './polyline';
import point from './point';

export {
    rectangle,
    polyline,
    point
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/annotations/defaults/index.js